import core from '../bundles/en/core';
import workspace from '../bundles/en/workspace';
import settings from '../bundles/en/settings';

const en = { ...core, ...workspace, ...settings } as const;

export type TranslationKey = keyof typeof en;
export default en;
